import { ReactElement } from 'react';
import { Route } from 'react-router';
import { SwitchWithNotFound } from '../../containers/SwitchWithNotFound';
import { NotFoundView } from '../../views/errors/NotFound.view';
import { InferenceDetailsDatasetsView } from '../../views/home/inferenceDetails/InferenceDetailsDatasets.view';
import { InferenceDetailsImagesView } from '../../views/home/inferenceDetails/InferenceDetailsImages.view';
import { InferenceDetailsMetricsView } from '../../views/home/inferenceDetails/InferenceDetailsMetrics.view';
import { Home } from '../config/Home';

export const InferenceDetailsRoute = (): ReactElement => (
  <SwitchWithNotFound notFound={<NotFoundView />}>
    <Route path={Home.Inferences.Details.Datasets.Path}>
      <InferenceDetailsDatasetsView />
    </Route>
    <Route path={Home.Inferences.Details.Images.Path}>
      <InferenceDetailsImagesView />
    </Route>
    <Route path={Home.Inferences.Details.Metrics.Path}>
      <InferenceDetailsMetricsView />
    </Route>
  </SwitchWithNotFound>
);

export const InferenceDetailsCreateRoute = (): ReactElement => (
  <SwitchWithNotFound notFound={<NotFoundView />}>
    <Route path={Home.Inferences.Create.Datasets.Path}>
      <InferenceDetailsDatasetsView />
    </Route>
    <Route path={Home.Inferences.Create.Images.Path}>
      <InferenceDetailsImagesView />
    </Route>
  </SwitchWithNotFound>
);
